import { render } from "./message-system.vue?vue&type=template&id=55c508aa&scoped=true&ts=true"
import script from "./message-system.vue?vue&type=script&lang=ts"
export * from "./message-system.vue?vue&type=script&lang=ts"

import "./message-system.vue?vue&type=style&index=0&id=55c508aa&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c508aa"]])

export default __exports__